import resourceReducerFactory, { resourceState } from 'reducers/resource';
import { types } from 'actions/cdrs-exports';

export const initialState = {
  ...resourceState,
  isCreating: false,
};

export default resourceReducerFactory(initialState, types);
